import { EntityBank } from "../../entity/EntityBank";

export class DtoBanksDeleteRes extends EntityBank {
  public message: string | null = null;
}
